module.exports = __webpack_public_path__ + "static/Oral rehabilitation smile before-fba7cf6ba23a52ec69d82027cac38789.jpg";